module.exports = __webpack_public_path__ + "static/cedric-9fa4037fc2a1951cb52afa0648826b07.jpg";